<template>
  <div class="container-fluid no-gutters no-padding h-100">
    <div id="app" class="row no-gutters h-100">
      <transition name="fade">
        <loading-screen v-show="(isLoading || this.$store.state.apiError)"></loading-screen>
      </transition>
      <div id="menu" class="col-lg-3">
        <b-navbar toggleable="lg" type="light" variant="white">
          <transition name="fade">
            <b-navbar-brand :to="{name: 'Start'}" id="brand-logo" v-if="animateLogo">
              <img class="logo-image" src="/assets/logo.png" alt="Stawiarska & Stala">
              <br>
              <img class="logo-caption d-none d-lg-inline" src="/assets/logo-txt.png">
            </b-navbar-brand>
          </transition>
          <b-navbar-toggle target="nav_menu">
            <font-awesome-icon icon="bars"/>
          </b-navbar-toggle>

          <b-collapse is-nav id="nav_menu">
            <transition name="fade-in-down">
              <b-nav vertical class="sidebar ml-auto mr-auto" v-if="otherAnimations">
                <b-nav-item :to="{ name: 'Start'}" class="hvr-underline-from-center">Strona główna</b-nav-item>
                <b-nav-item
                  :to="{ name: 'Specjalizacje'}"
                  class="hvr-underline-from-center"
                >Specjalizacje</b-nav-item>
                <b-nav-item :to="{ name: 'Zespol'}" class="hvr-underline-from-center">Zespół</b-nav-item>
                <b-nav-item
                  :to="{ name: 'Aktualnosci'}"
                  class="hvr-underline-from-center"
                >Aktualności</b-nav-item>
                <b-nav-item :to="{ name: 'Kariera'}" class="hvr-underline-from-center">Kariera</b-nav-item>
                <b-nav-item :to="{ name: 'Kontakt'}" class="hvr-underline-from-center">Kontakt</b-nav-item>
              </b-nav>
            </transition>
          </b-collapse>
        </b-navbar>
      </div>
      <main id="main" class="col-lg-9">
        <transition name="fade">
          <router-view v-show="loadComponent"></router-view>
        </transition>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api_error: false,
      isLoading: true,
      animateLogo: false,
      otherAnimations: false,
      loadComponent: false
    };
  },
  name: "app",
  beforeCreate() {
    if(this.$store.state.pages.length === 0) {
        this.$store.dispatch('getPages');
      }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      if(this.$store.state.pages.lenth === 0) {
        this.$store.dispatch('getPages');
      }
      this.loadComponent = false;
      next();
    });
    this.$router.afterEach((to, from) => {
      this.loadComponent = true;
    });
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
    setTimeout(() => {
      this.animateLogo = true;
    }, 2500);
    setTimeout(() => {
      this.otherAnimations = true;
    }, 3000);
    setTimeout(() => {
      this.loadComponent = true;
    }, 4000);
  },

};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-in-down-enter-active {
  -webkit-animation: fade-in-down;
  animation: fade-in-down;
  animation-duration: 1s;
}
.fade-in-down-enter {
  opacity: 0;
}

@-webkit-keyframes fade-in-down {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fade-in-down {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Enriqueta:400,700|Fira+Sans:100,400,500,600&subset=latin-ext");
html {
  font-size: 62.5%;
}
body {
  font-size: calc(1.4rem + 0.25vw);
  color: #292a2b;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Enriqueta", serif;
}
.img-responsive {
  width: 100%;
}
#app {
  font-family: "Fira Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  max-width: 1360px;
}
#menu {
  font-family: "Enriqueta", serif;
  text-transform: uppercase;
}
#nav_menu {
  text-align: right;
  font-size: 2.4rem;
}
#menu .navbar-toggler {
  border: 0px;
  font-size: 6rem;
  color: #292a2b !important;
}
#main {
  margin: 0;
  padding: 0;
}
.navbar {
  padding: 4rem 3rem;
}
.page {
  padding: 3rem 2rem 0rem 2rem;
  position: relative;
  min-height: 100%;
  background: #fff;
}
.k-background {
  position: relative;
  z-index: 1;
}
#brand-logo {
  text-align: center;
  background: #fff;
}
a,
a:hover,
a:active,
.navbar a,
.nav-link,
.nav-link:active,
.nav-link:hover {
  color: #292a2b;
}
a.more {
  text-align: right;
  display: inline-block;
  float: right;
  padding-bottom: 2rem;
  text-decoration: none;
  text-transform: uppercase;
}
a.underline-link {
  text-decoration: underline;
  font-weight:bold;
}
.nav-item.hvr-underline-from-center::before {
  background: #8b8b8b;
  height: 2px;
}
.no-padding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.content {
  margin-top: 3rem;
  margin-bottom: -2rem;
  padding: 4rem 4rem 5rem 4rem;
  margin-left: -2rem;
  margin-right: -2rem;
  box-sizing: border-box;
}
p {
  margin-bottom: 2rem;
}
p.intro::after {
  content: "";
  display: block;
  width: 100%;
  margin-top: 2rem;
  border-bottom: 0.1rem solid #8b8b8b;
}

.page ul {
  margin-left: 0;
  padding-left: 2rem;
}
.page-nav {
  font-size: 4rem;
  margin-bottom: 0rem;
}
.spec-content {
  padding: 2rem 3rem;
}

@media (max-width: 959px) {
  #brand-logo .logo-image {
    height: 100px;
  }
}
@media (min-width: 760px) {
  .row-md-h-100 {
    height: 100% !important;
  }
}

@media (min-width: 960px) {
  .page {
    background: rgba(227, 232, 235, 1);
    background: -moz-linear-gradient(
      left,
      rgba(227, 232, 235, 1) 0%,
      rgba(227, 232, 235, 1) 34%,
      rgba(255, 255, 255, 1) 100%
    );
    background: -webkit-gradient(
      left top,
      right top,
      color-stop(0%, rgba(227, 232, 235, 1)),
      color-stop(34%, rgba(227, 232, 235, 1)),
      color-stop(100%, rgba(255, 255, 255, 1))
    );
    background: -webkit-linear-gradient(
      left,
      rgba(227, 232, 235, 1) 0%,
      rgba(227, 232, 235, 1) 34%,
      rgba(255, 255, 255, 1) 100%
    );
    background: -o-linear-gradient(
      left,
      rgba(227, 232, 235, 1) 0%,
      rgba(227, 232, 235, 1) 34%,
      rgba(255, 255, 255, 1) 100%
    );
    background: -ms-linear-gradient(
      left,
      rgba(227, 232, 235, 1) 0%,
      rgba(227, 232, 235, 1) 34%,
      rgba(255, 255, 255, 1) 100%
    );
    background: linear-gradient(
      to right,
      rgba(227, 232, 235, 1) 0%,
      rgba(227, 232, 235, 1) 34%,
      rgba(255, 255, 255, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e3e8eb', endColorstr='#ffffff', GradientType=1 );
  }
  #menu {
    float: left;
  }
  #main {
    float: right;
  }

  #nav_menu {
    float: left;
    width: 100%;
    padding-top: 2rem;
    text-align: left;
  }
  .navbar {
    flex-direction: column !important;
    padding: 4rem 3rem;
  }
  #brand-logo {
    max-height: auto;
  }
  #brand-logo .logo-image {
    width: 60%;
    clear: both;
  }
  #brand-logo .logo-caption {
    width: 80%;
    padding-top: 2.5rem;
    clear: both;
  }
}
</style>
